var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import { classMap, Component, html, nothing, Prop, Watch } from '@sick-davinci/ce-decorators';
import { IconRef } from '@sick-davinci/basic-elements';
import { style } from './NavigationMenu.style';
import { NavigationMenuItem } from './navigation-menu-item/NavigationMenuItem';
import { icon_more_horiz as menuIcon } from '@sick-davinci/material-icons/navigation/more_horiz.icon';
/**
 * THIS IS NOT INTENDED TO BE USED MANUALLY BY A DEVELOPER ! ! !
 * A 'davinci-navigation-menu' renders a "more"-button with a list of 'davinci-navigation-menu-item's.
 * It is created automatically by a 'davinci-core-navigation' and represents parts of its 'davinci-core-navigation-item's.
 */
export let NavigationMenu = (_dec = Component({
  tag: 'davinci-navigation-menu',
  style,
  // tslint:disable-line:no-unsafe-any
  dependencies: [IconRef]
}), _dec2 = Prop({
  type: Boolean
}), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Watch('open'), _dec5 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = class NavigationMenu extends NavigationMenuItem {
  constructor(...args) {
    super(...args);
    /**
     * Indicates, if the Items are displayed (true), or not (false)
     */
    _initializerDefineProperty(this, "open", _descriptor, this);
    _defineProperty(this, "closeOnClick", () => {
      this.open = false;
    });
    _defineProperty(this, "_onSlotChange", _event => {
      this._configureSubItems();
    });
  }
  onOpenChange() {
    // defer listener registration to next tick.
    // Skip the bubbled opening event, to not close the menu again, immediately.
    this.open ? setTimeout(() => document.body.addEventListener('click', this.closeOnClick), 0) : document.body.removeEventListener('click', this.closeOnClick);
  }
  componentFirstRender() {
    this._configureSubItems();
  }
  render() {
    return html`
      ${[this._renderButton(), this._renderItemList()]}
    `;
  }
  _renderButton() {
    const classes = {
      'menu-button': true,
      'open': this.open
    };
    return html`<davinci-icon-ref
      class="${classMap(classes)}"
      .src="${menuIcon}"
      @click="${this._toggleMenu}"
    ></davinci-icon-ref>`;
  }
  _renderItemList() {
    return this.open ? html`
      <div class="menu" @click="${this._toggleMenu}">
        <div class="inner-container">
          <div class="item-list"><slot @slotchange="${this._onSlotChange}"></slot></div>
        </div>
      </div>
      ` : nothing;
  }
  _configureSubItems() {
    for (const item of this.children) {
      if (item.tagName !== 'DAVINCI-NAVIGATION-MENU-ITEM') {
        throw new Error('`DAVINCI-NAVIGATION-MENU` must only contain `DAVINCI-NAVIGATION-MENU-ITEM` children, but ' + item.tagName + ' was found');
      }
    }
    if (this.children.length) {
      Array.from(this.children).forEach((child, index) => {
        if (this.children.length - 1 === index) {
          child.setAttribute('last', 'last');
        } else {
          child.removeAttribute('last');
        }
      });
    }
  }
  _toggleMenu() {
    this.open = !this.open;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "open", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "onOpenChange", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "onOpenChange"), _class2.prototype)), _class2)) || _class);
